import { useContext , useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import PageTitle from "../../layouts/PageTitle";
import { ContextApi } from "../../../store/ContextApi";
import ReactQuill from "react-quill";
import { toast } from "react-toastify";
import { postWhatsappMessageFunc } from "../../../store/custom-actions/whatsapp-actions/PostWhatsappMessageSlicer";
import { useTranslation } from "react-i18next";

function WhatsappForm() {
    const {t} = useTranslation();
    const contextApi = useContext(ContextApi);
    const whatsappApi = `${process.env.REACT_APP_VERSEL_API}/api/dashboard/whats-app`;
    const {loading:postWhatsappMessageLoading} = useSelector(
        state => state.postWhatsappMessageSlicer
    );
    const dispatch = useDispatch();
    const [whatsappMesage , setWhatsappMessage] = useState("")
    const {handleSubmit} = useForm();

    const handleSubmitSettings = async (data) => {
        if(data) {
            const messageForm = new FormData();
            messageForm.append("message" , whatsappMesage)
            dispatch(postWhatsappMessageFunc({
                api : whatsappApi , 
                data : messageForm
            }))
            .then(result => {
                if(result.payload.success === true) {
                    setWhatsappMessage("")
                    toast.success(`${t(result.payload.message)} !`, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                    })
                }
            })
        }
    }
    const colors = [
        '#000000', '#e60000', '#ff9900', '#ffff00', '#008a00', '#0066cc', '#9933ff',
        '#ffffff', '#facccc', '#ffebcc', '#ffffcc', '#cce8cc', '#cce0f5', '#ebd6ff',
        '#bbbbbb', '#f06666', '#ffc266', '#ffff66', '#66b966', '#66a3e0', '#c285ff',
        '#888888', '#a10000', '#b26b00', '#b2b200', '#006100', '#0047b2', '#6b24b2',
        '#444444', '#5c0000', '#663d00', '#666600', '#003700', '#002966', '#3d1466',
        '#000000', '#990000', '#b26b00', '#b2b200', '#005c00', '#003399', '#592966'
    ];
    const modules = {
        toolbar: {
        container: [
        [{"color" : colors}],
        [{ 'background': colors }]
        [{ 'header': [1, 2, 3, false] }],
        ['bold', 'italic', 'underline', 'strike'],
        ['link' , "video"],
        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
        [{ 'align': [] }],
        ['clean']
        ],
    }
    };
    return (
        <>
            <PageTitle motherMenu={"Dashboard"} activeMenu={"Whatsapp Message"} customClasses={"mb-0"}/>
            <div className="relative flex items-center justify-between my-3">
                <div className="relative flex items-center">
                    {/* <button className="rounded-lg relative w-36 h-10 cursor-pointer flex items-center border border-blue-500 bg-blue-500 group hover:bg-blue-500 active:bg-blue-500 active:border-blue-500 overflow-hidden"
                        onClick={() => window.history.back()}
                    >
                        <span className="text-gray-200 font-semibold ml-8 transform group-hover:translate-x-20 transition-all duration-300">Back</span>
                        <span className="absolute right-0 h-full w-10 rounded-lg bg-blue-500 flex items-center justify-center transform group-hover:translate-x-0 group-hover:w-full transition-all duration-300">
                            <i className="fa-solid fa-arrow-left text-white"></i>
                        </span>
                    </button> */}
                    <button 
                        type="submit"
                        form="whatsapp-message-form"
                        className={`flex items-center bg-primary text-white gap-1 px-4 py-2 cursor-pointer  font-semibold tracking-widest rounded-md hover:bg-blue-400 duration-300 ml-1 hover:gap-2 hover:translate-x-3
                        ${postWhatsappMessageLoading ? "pointer-events-none opacity-80" : ""}
                        `}
                        >
                            {
                                postWhatsappMessageLoading
                                ?
                                t("Loading")
                                :
                                <>
                                    {t("Send")}
                                    <i className="fa-solid fa-paper-plane text-white ml-1"></i>
                                </>
                            }
                    </button>
                </div>
            </div>
            
            {
                <div className="relative settings-form-content">
                <div className="whatsapp-message-form-div relative w-full ">
                    <form 
                        className="whatsapp-message-form"
                        id="whatsapp-message-form"
                        onSubmit={handleSubmit((data) => {
                            handleSubmitSettings(data)
                        })}
                    >
                        {
                            <>
                                {/* <div className={'row'}>
                                    <div className="form-group mb-3 col-sm-12 col-md-6">
                                        <label className="flex items-center">
                                            <i className="fa-solid fa-arrow-up-9-1 mr-1"></i>
                                            Site Title
                                        </label>
                                        {errors.site_title?.message && (
                                        <p className="text-red-600">
                                            {errors.site_title?.message}
                                        </p>
                                        )}
                                        <input
                                        {...register("site_title")}
                                        type="text"
                                        className="form-control"
                                        />
                                    </div>
                                    <div className="form-group mb-3 col-sm-12 col-md-6">
                                        <label className="flex items-center">
                                            <i className="fa-solid fa-arrow-up-9-1 mr-1"></i>
                                            Site Global Email
                                        </label>
                                        {errors.site_global_email?.message && (
                                        <p className="text-red-600">
                                            {errors.site_global_email?.message}
                                        </p>
                                        )}
                                        <input
                                        {...register("site_global_email")}
                                        type="email"
                                        className="form-control"
                                        />
                                    </div>
                                </div> */}
                                <div className="row">
                                    <label className="flex items-center">
                                        <i className="fa-solid fa-arrow-up-9-1 mr-1"></i>
                                        {t("Message Content")}
                                    </label>
                                    {/* <ReactQuill 
                                    modules = {modules}
                                    className="p-0 border-none outline-none form-control bg-white " 
                                    value={whatsappMesage} 
                                    theme="snow" 
                                    onChange={(content) => setWhatsappMessage(content)} /> */}
                                    <textarea className="form-control p-2" rows={7} placeholder={`${t("Message Content")}...`}
                                    value={whatsappMesage} 
                                    onChange={(e) => setWhatsappMessage(e.target.value)}
                                    ></textarea>
                                </div>
                            </>
                        }
                    </form>
                </div>
                </div>
            }
        </>
    )
}


export default WhatsappForm;